import { render, staticRenderFns } from "./ActionVerificationCompleted.vue?vue&type=template&id=6e6f968e&"
import script from "./ActionVerificationCompleted.vue?vue&type=script&lang=js&"
export * from "./ActionVerificationCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports